import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Terminal"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-terminal',
    templateUrl: './icon-terminal.component.html',
    styleUrls: ['./icon-terminal.component.scss'],
    standalone: false
})
export class IconTerminalComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
